import styled from 'styled-components';
import InputMask from 'react-input-mask';

interface InputProps {
  id: string;
  error: boolean;
}

interface ButtonProps {
  disabled?: boolean;
}

export const Text = styled.div`
  display: flex;
  /* align-self: flex-start; */
  align-self: center;
  font-family: Arial, sans-serif;
  font-size: 1.2rem;
  margin: 10px 0;
  color: ${(props) => props.theme.colors.gray};
  @media screen and (min-width: 960px) {
    align-self: center;
  }
`;

export const PreviewContainer = styled.div`
  font-weight: 700;
  font-size: 32px;
  color: ${(props) => props.theme.colors.primary};
  margin: 10px 0px 20px 0px;
  font-family: Arial, sans-serif;

  @media screen and (max-width: 960px) {
    font-size: 24px;
  }
`;

export const ContainerInteraction = styled.div`
  display: flex;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Input = styled(InputMask)<InputProps>`
  width: 152px;
  height: 72px;
  background: ${(props) => props.theme.colors.white};
  font-weight: 400;
  font-family: Arial, sans-serif;
  font-size: 22px;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '10px'};
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.4);
  text-align: center;
  margin-right: 10px;
  border: ${(props) =>
    props.error ? `2px solid ${props.theme.colors.danger}` : 'none'};

  @media screen and (max-width: 960px) {
    width: 138px;
    height: 58px;
    font-size: 18px;
  }
`;

export const AuthButton = styled.button<ButtonProps>`
  background: ${(props) => props.theme.colors.primary};
  color: #fff;
  width: 152px;
  padding: 5px 0px;
  height: 72px;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '10px'};
  font-weight: 700;
  font-size: 20px;
  text-transform: uppercase;
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.4);

  @media screen and (max-width: 960px) {
    width: 138px;
    height: 58px;
    font-size: 18px;
  }
`;

export const TagError = styled.div`
  position: absolute;
  z-index: 20;
  padding: 3px 8px 2px 8px;
  background: ${(props) => props.theme.colors.danger};
  font-weight: 700;
  text-align: center;
  font-size: 14px;
  color: ${(props) => props.theme.colors.white};
  width: max-content;
  border-radius: 16px;
  bottom: -10px;
  left: 27px;
  margin: 0 auto;

  @media screen and (max-width: 960px) {
    left: 20px;
  }
`;
